import React, { Fragment } from "react";

import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { Row, Col } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import Logo from "../../../../../assets/Logo.png";

const styles = StyleSheet.create({
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: 30,
  },
  mainHeader: {
    display: "flex",
    padding: "0px 20px",
    paddingTop: "10px",
    // justifyContent: "space-between",
    flexDirection: "column",
    alignItems: "center",
    color: "black",
    // backgroundColor: "#284F68",
  },
  headerLogo: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    padding: "10px",
  },
  headerTextSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    color: "black",
    fontSize: 12,
    textAlign: "center",
  },
  taxPersonsSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    color: "black",
    textAlign: "left",
  },
  headingText: {
    fontSize: "23px",
    marginBottom: "5px",
    // color: "#fff",
    display: "block",
  },
  propertyDetailsContainer: {
    display: "block",
    width: "100%",
    border: "black 1px solid",
    marginTop: 40,
  },
  footer: {
    display: "block",
    width: "100%",
    marginTop: 40,
  },
  propertyDetailsRow: {
    border: "black 1px solid",
    paddingLeft: 10,
  },
  rowTextSize: {
    fontSize: 10,
  },
  blackBackgroundWhiteText: {
    backgroundColor: "#000",
    color: "#fff",
  },
  noOccupierText: {
    marginLeft: "10px",
  },
});

const occupiersDetails = (data) => {
  return (
    <View style={{ ...styles.propertyDetailsContainer }}>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={24}
        >
          Occupier Details
        </Col>
        {data?.occupiers?.length > 0 ? (
          <>
            {data?.occupiers.map((element,index) => {
              if(index<2)
              {
                return (
                  <Fragment>
                    <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                      <b style={{color:'black'}}>Name</b>
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                      <b style={{color:'black'}}>S/0, D/0, W/0</b>
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                      <b style={{color:'black'}}>CNIC</b>
                    </Col>
  
                    <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                      {element?.name}
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                      {element?.father_name}
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                      {element?.cnic}
                    </Col>
  
                    <Col style={{ ...styles.propertyDetailsRow }} span={12}>
                      <b style={{color:'black'}}>Cell Number</b>
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={12}>
                      <b style={{color:'black'}}>Email</b>
                    </Col>
  
                    <Col style={{ ...styles.propertyDetailsRow }} span={12}>
                      {element?.phone_number}
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={12}>
                      {element?.email}
                    </Col>
                  </Fragment>
                );
              }
              else
              {
                return (
                  <Fragment>
                    <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                      <b style={{color:'black'}}>Name</b>
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                      <b style={{color:'black'}}>S/0, D/0, W/0</b>
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                      <b style={{color:'black'}}>CNIC</b>
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                      <b style={{color:'black'}}>Cell Number</b>
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                      {element?.name}
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                      {element?.father_name}
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                      {element?.cnic}
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                      {element?.phone_number}
                    </Col>
                  </Fragment>
                );
              }
              
            })}
          </>
        ) : (
          <div style={{ ...styles.noOccupierText }}>No Occupier added.</div>
        )}
      </Row>
    </View>
  );
};
const ownersDetails = (data) => {
  return (
    <View style={{ ...styles.propertyDetailsContainer }}>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={24}
        >
          Owner Details
        </Col>

        {data?.property_owners?.map((element,index) => {
          if(index<2)
          {
            return (
              <Fragment>
                <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                  <b style={{color:'black'}}>Name</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                  <b style={{color:'black'}}>S/0, D/0, W/0</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                  <b style={{color:'black'}}>CNIC</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                  {element?.name}
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                  {element?.father_name}
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                  {element?.cnic}
                </Col>
  
                <Col style={{ ...styles.propertyDetailsRow }} span={12}>
                  <b style={{color:'black'}}>Cell Number</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={12}>
                  <b style={{color:'black'}}>Email</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={12}>
                  {element?.phone_number}
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={12}>
                  {element?.email}
                </Col>
              </Fragment>
            );
          }
          else
          {
            return (
              <Fragment>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b style={{color:'black'}}>Name</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b style={{color:'black'}}>S/0, D/0, W/0</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b style={{color:'black'}}>CNIC</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b style={{color:'black'}}>Cell Number</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  {element?.name}
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  {element?.father_name}
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  {element?.cnic}
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  {element?.phone_number}
                </Col>
              </Fragment>
            );
          }
          
        })}
      </Row>
    </View>
  );
};
const propertyAndHighwayInformationView = (data) => {
  return (
    <View style={{ ...styles.propertyDetailsContainer }}>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={24}
        >
          Property and Highway Information
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Highway/Motorway Name</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.highway?.name}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>From</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.highway_from}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>To</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.highway_to}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>KMs</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.highway_kms}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Classification of Property</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.atv?.property_type}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Property Number</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.id}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>PIN</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.pin}
        </Col>
      </Row>
    </View>
  );
};
const propertyDetailView = (data) => {
  return (
    <View style={{ ...styles.propertyDetailsContainer }}>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={24}
        >
          Property Details
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>District</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.district?.name}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Mouza</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.mouza?.name}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Khasra No.</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.khasra_number}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Circle</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.circle?.name}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}} >Type of Property</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.property_type?.name}
        </Col>
      </Row>
    </View>
  );
};
const atvDetails = (data) => {
  return (
    <View style={{ ...styles.propertyDetailsContainer }}>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={24}
        >
          Information Regarding Calculation of ATV
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Land Area</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.formattedLandAreas?.filter((e) => e.type === "RESIDENTIAL")
            .length > 0 &&
          data?.formattedLandAreas?.filter((e) => e.type === "COMMERCIAL")
            .length > 0
            ? `${
                data?.formattedLandAreas?.[
                  data?.formattedLandAreas?.findIndex(
                    (e) => e.type === "COMMERCIAL"
                  )
                ]?.area
              } ${
                data?.formattedLandAreas?.[
                  data?.formattedLandAreas?.findIndex(
                    (e) => e.type === "COMMERCIAL"
                  )
                ]?.unit
              } Commercial, ${
                data?.formattedLandAreas?.[
                  data?.formattedLandAreas?.findIndex(
                    (e) => e.type === "RESIDENTIAL"
                  )
                ]?.area
              } ${
                data?.formattedLandAreas?.[
                  data?.formattedLandAreas?.findIndex(
                    (e) => e.type === "RESIDENTIAL"
                  )
                ]?.unit
              } Residential`
            : (data?.formattedLandAreas?.filter((e) => e.type === "COMMERCIAL")
                .length > 0 &&
                `${
                  data?.formattedLandAreas?.[
                    data?.formattedLandAreas?.findIndex(
                      (e) => e.type === "COMMERCIAL"
                    )
                  ]?.area
                } ${
                  data?.formattedLandAreas?.[
                    data?.formattedLandAreas?.findIndex(
                      (e) => e.type === "COMMERCIAL"
                    )
                  ]?.unit
                } Commercial`) ||
              (data?.formattedLandAreas?.filter((e) => e.type === "RESIDENTIAL")
                .length > 0 &&
                `${
                  data?.formattedLandAreas?.[
                    data?.formattedLandAreas?.findIndex(
                      (e) => e.type === "RESIDENTIAL"
                    )
                  ]?.area
                } ${
                  data?.formattedLandAreas?.[
                    data?.formattedLandAreas?.findIndex(
                      (e) => e.type === "RESIDENTIAL"
                    )
                  ]?.unit
                } Residential`)}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>DC Rate(s)</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.dcRates?.filter((e) => e.type === "RESIDENTIAL").length > 0 &&
          data?.dcRates?.filter((e) => e.type === "COMMERCIAL").length > 0
            ? `${
                data?.dcRates?.[
                  data?.dcRates?.findIndex((e) => e.type === "COMMERCIAL")
                ]?.dcRate
              } for Commercial, ${
                data?.dcRates?.[
                  data?.dcRates?.findIndex((e) => e.type === "RESIDENTIAL")
                ]?.dcRate
              } for Residential`
            : (data?.dcRates?.filter((e) => e.type === "RESIDENTIAL").length >
                0 &&
                `${
                  data?.dcRates?.[
                    data?.dcRates?.findIndex((e) => e.type === "RESIDENTIAL")
                  ]?.dcRate
                } for Residential`) ||
              (data?.dcRates?.filter((e) => e.type === "COMMERCIAL").length >
                0 &&
                `${
                  data?.dcRates?.[
                    data?.dcRates?.findIndex((e) => e.type === "COMMERCIAL")
                  ]?.dcRate
                } for Commercial`)}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Covered Area (Sq. ft.)</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.floorCoveredAreas?.rccCommercial +
            data?.floorCoveredAreas?.nonRccCommercial >
            0 &&
          data?.floorCoveredAreas?.rccResidential +
            data?.floorCoveredAreas?.nonRccResidential >
            0
            ? `${
                data?.floorCoveredAreas?.rccCommercial +
                data?.floorCoveredAreas?.nonRccCommercial
              } Commercial, ${
                data?.floorCoveredAreas?.rccResidential +
                data?.floorCoveredAreas?.nonRccResidential
              } Residential`
            : (data?.floorCoveredAreas?.rccCommercial +
                data?.floorCoveredAreas?.nonRccCommercial >
                0 &&
                `${
                  data?.floorCoveredAreas?.rccCommercial +
                  data?.floorCoveredAreas?.nonRccCommercial
                } Commercial`) ||
              (data?.floorCoveredAreas?.rccResidential +
                data?.floorCoveredAreas?.nonRccResidential >
                0 &&
                `${
                  data?.floorCoveredAreas?.rccResidential +
                  data?.floorCoveredAreas?.nonRccResidential
                } Residential`)}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Structure Rate(s)</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.structureRates?.filter((e) => e.type === "RESIDENTIAL").length >
            0 &&
          data?.structureRates?.filter((e) => e.type === "COMMERCIAL").length > 0
            ? `${
                data?.structureRates?.[
                  data?.structureRates?.findIndex((e) => e.type === "COMMERCIAL")
                ]?.structureRate
              } for Commercial, ${
                data?.structureRates?.[
                  data?.structureRates?.findIndex(
                    (e) => e.type === "RESIDENTIAL"
                  )
                ]?.structureRate
              } for Residential`
            : (data?.structureRates?.filter((e) => e.type === "RESIDENTIAL")
                .length > 0 &&
                `${
                  data?.structureRates?.[
                    data?.structureRates?.findIndex(
                      (e) => e.type === "RESIDENTIAL"
                    )
                  ]?.structureRate
                } for Residential`) ||
              (data?.structureRates?.filter((e) => e.type === "COMMERCIAL")
                .length > 0 &&
                `${
                  data?.structureRates?.[
                    data?.structureRates?.findIndex(
                      (e) => e.type === "COMMERCIAL"
                    )
                  ]?.structureRate
                } for Commercial`)}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Type of Structure</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.floorCoveredAreas?.rccCommercial +
            data?.floorCoveredAreas?.rccResidential >
            0 &&
          data?.floorCoveredAreas?.nonRccCommercial +
            data?.floorCoveredAreas?.nonRccResidential >
            0
            ? `RCC, Non-RCC`
            : (data?.floorCoveredAreas?.rccCommercial +
                data?.floorCoveredAreas?.rccResidential >
                0 &&
                `RCC`) ||
              (data?.floorCoveredAreas?.nonRccCommercial +
                data?.floorCoveredAreas?.nonRccResidential >
                0 &&
                `Non-RCC`)}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Annual Taxable Value</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {"RS. " + data?.atv?.annual_taxable_value?.toLocaleString()}
        </Col>
      </Row>
    </View>
  );
};
const furtherInformation = (data) => {
  return (
    <View style={{ ...styles.propertyDetailsContainer }}>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={24}
        >
          Further Information
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Geotagging</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {data?.latitude + "," + data?.longitude}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Documentary Proof</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {isDocumentsAttached(data) ? "Attached" : "Not Attached"}
        </Col>

        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>Property Pictures</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
          {isPropertyDocumentAttached(data) ? "Attached" : "Not Attached"}
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={6}>
          <b style={{color:'black'}}>E.T.O with initials</b>
        </Col>
        <Col style={{ ...styles.propertyDetailsRow }} span={18}>
         {data?.user?.full_name}
        </Col>

        {/* <Col style={{...styles.propertyDetailsRow}} span={6}><b>AE.T.O</b></Col>
                <Col style={{...styles.propertyDetailsRow}} span={18}>Lahore</Col>

                <Col style={{...styles.propertyDetailsRow}} span={6}><b>E.T.O with Initials</b></Col>
                <Col style={{...styles.propertyDetailsRow}} span={18}>Lahore</Col> */}
      </Row>
    </View>
  );
};
const footer = (data) => {
  return (
    <View style={{ ...styles.footer }}>
      <Row>
        <Col span={24} style={{ marginBottom: 30 }}>
          Date: <b>{moment().format("DD-MM-YYYY")}</b>
        </Col>

        <Col span={5}>Signature ETI:__________</Col>
        <Col span={14}></Col>
        <Col span={5}>Stamp:___________</Col>
      </Row>
    </View>
  );
};
const isDocumentsAttached = (data) => {
  const isOccupierDocsAttached = data?.occupiers?.some(
    (item) => item?.documents?.length > 0
  );
  const isOwnerDocsAttached = data?.property_owners?.some(
    (item) => item?.documents?.length > 0
  );

  return isOccupierDocsAttached || isOwnerDocsAttached;
};
const isPropertyDocumentAttached = (data) => {
  const isPropDocsAttached = data?.documents?.length > 0;

  return isPropDocsAttached;
};
const PhOneFormPdf = ({ data }) => (
  <Document>
    <Page pageNumber={1} wrap>
      <View style={{ ...styles.page }}>
        <View style={styles.mainHeader}>
          <View style={{ ...styles.headerLogo }}>
            <img src={Logo}></img>
          </View>
          <View style={{ ...styles.headerTextSection, ...styles.rowTextSize }}>
            <Text style={{ fontSize: 14 }}>
              Punjab Tax on Properties other than Agricultural Land abutting to
              National/Provincial Highways and within the area of Motorways
              outside the Rating Areas Rules
            </Text>
            <Text>{moment(data?.tax_collection?.year).format("YYYY")}</Text>
            <Text>
              <b>FORM PH-1</b>
            </Text>
          </View>
        </View>
        <View style={{ ...styles.taxPersonsSection }}>
          <Text style={{ ...styles.rowTextSize }}>
          <b style={{color:'black'}}> Taxation Inspector Name : </b>
            <b>{data?.property_inspector?.user?.full_name}</b>
          </Text>
          <Text style={{ ...styles.rowTextSize }}>
             <b style={{color:'black'}}>Name of ETO : </b><b>{data?.user?.full_name}</b>
          </Text>
          <Text style={{ ...styles.rowTextSize }}>
          <b style={{color:'black'}}>Serial No : </b><b>{data?.ph1s[0]?.serial_number}</b>
          </Text>
        </View>

        {propertyDetailView(data)}
        {propertyAndHighwayInformationView(data)}
        {ownersDetails(data)}
        {occupiersDetails(data)}
        {atvDetails(data)}
        {furtherInformation(data)}
        {footer(data)}
      </View>
    </Page>
  </Document>
);

const mapStateToProps = ({ property: { currentProperty } }) => ({
  currentProperty,
});

const mapDispatchToProps = (dispatch) => ({});

PhOneFormPdf.propTypes = {
  currentProperty: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(PhOneFormPdf);
